module.exports = __webpack_public_path__ + "static/media/padlock.bc4ca4d8.svg";